import { render, staticRenderFns } from "./generic-overview-donut-chart.vue?vue&type=template&id=40a41dd5&"
import script from "./generic-overview-donut-chart.vue?vue&type=script&lang=js&"
export * from "./generic-overview-donut-chart.vue?vue&type=script&lang=js&"
import style0 from "./generic-overview-donut-chart.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a41dd5')) {
      api.createRecord('40a41dd5', component.options)
    } else {
      api.reload('40a41dd5', component.options)
    }
    module.hot.accept("./generic-overview-donut-chart.vue?vue&type=template&id=40a41dd5&", function () {
      api.rerender('40a41dd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/generic-overview-donut-chart/generic-overview-donut-chart.vue"
export default component.exports